import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { HANDOVER_STATUS_ACCEPTED } from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { Mandril } from 'src/app/interfaces/mandril';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SectionTouched } from '../../shared/section-touched.class';

@Component({
  selector: 'app-handover-detail-mandril',
  templateUrl: './handover-detail-mandril.component.html',
  styleUrls: ['./handover-detail-mandril.component.scss'],
  standalone: false,
})
export class HandoverDetailMandrilComponent
  extends SectionTouched
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() readOnlyContent!: boolean;
  mandrils: Mandril[] = [];
  displayedColumns = [
    'numMandril',
    'tipoValvula',
    'estadoMandril',
    'profundidadTope',
    'profundidadBase',
    'ultimoVRF',
    'fecha',
    'actions',
  ];
  originalMandrils: Mandril[] = [];
  isLoading = false;
  hideFooter = true;
  isDisabled: boolean[] = [];
  showFooterNoDataOrign = false;

  constructor(
    public handoverService: HandoverService,
    public dialogService: DialogService,
    public notificationService: NotificationService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handover != undefined) {
      this.showFooterNoDataOrign =
        this.handover.handoverStatusId != HANDOVER_STATUS_ACCEPTED;
    }
    this.getMandrils();
  }

  getMandrils(): void {
    if (this.handover != undefined) {
      this.isLoading = true;
      this.handoverService
        .getMandrils(
          this.handover.handoverId!,
          this.handover.wellId!,
          this.handover.wellUwi,
          this.handover.handoverStatusId!
        )
        .subscribe((mandrils: Mandril[]) => {
          this.mandrils = mandrils;
          this.setOriginalMandrilsValues(mandrils);
          this.isLoading = false;
          this.hideFooter = this.mandrils.length > 0;
        });
    }
  }

  setOriginalMandrilsValues(mandrils: Mandril[]): void {
    this.originalMandrils = mandrils.map((mandril) => {
      this.isDisabled.push(true);
      if (mandril.comments == null) mandril.comments = '';
      return Object.assign({ isDisabled: true }, mandril);
    });
  }

  enableSaveButton(i: number): void {
    const oSp = this.originalMandrils[i];
    const enable = this.mandrils[i].comments != oSp.comments;
    this.isDisabled[i] = !enable;
    this.reportPendingChanges();
  }

  openComments(
    element: Mandril,
    index: number,
    event: any,
    readOnly: boolean
  ): void {
    const target = new ElementRef(event.currentTarget);
    this.dialogService
      .openCommentDialog(
        'Comentario del mandril',
        this.mandrils[index].comments,
        target,
        -200,
        -450,
        readOnly
      )
      .afterClosed()
      .subscribe((comments: string) => {
        this.mandrils[index].comments = comments;
        this.enableSaveButton(index);
      });
  }

  save(element: Mandril, index: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Mandril',
      `¿Desea guardar los cambios realizados en el Mandril ${element.numMandril}?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        element.handoverId = this.handover?.handoverId;
        const mandrils: Mandril[] = [];
        mandrils.push(element);

        this.handoverService
          .saveMandrils(mandrils)
          .subscribe((savedMandrils: Mandril[]) => {
            if (savedMandrils) {
              this.notificationService.notify(
                `Los cambios en el Mandril ${element.numMandril} se han guardado con éxito.`,
                true
              );
              this.isDisabled[index] = true;
              this.originalMandrils[index].comments = element.comments;
              this.reportPendingChanges();
            } else {
              this.notificationService.notify(
                `Ocurrió un error al grabar los cambios en el Mandril ${element.numMandril}.`,
                false
              );
            }
          });
      }
    });
  }

  reportPendingChanges(): void {
    let thereAreChanges = false;
    for (let index = 0; index < this.mandrils.length; index++) {
      thereAreChanges =
        thereAreChanges ||
        this.mandrils[index].comments != this.originalMandrils[index].comments;
    }
    this.emitPendingChanges(thereAreChanges);
  }
}
